import { render, staticRenderFns } from "./FileShareAddConfirmView.vue?vue&type=template&id=0055369f&scoped=true"
import script from "./FileShareAddConfirmView.vue?vue&type=script&lang=js"
export * from "./FileShareAddConfirmView.vue?vue&type=script&lang=js"
import style0 from "./FileShareAddConfirmView.vue?vue&type=style&index=0&id=0055369f&prod&lang=scss&scoped=true"
import style1 from "./FileShareAddConfirmView.vue?vue&type=style&index=1&id=0055369f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0055369f",
  null
  
)

export default component.exports